import {TowingOrderJobInterface} from "./types";
import {
  RepairShop  
} from "../../containers/TowingRecordPage/components/routes/subforms/FinishRoute/options";

export function getRepairShop(repairShops: RepairShop[],towingOrder: TowingOrderJobInterface): RepairShop | undefined {

  if(towingOrder.automobileAndTouringClubFinland && towingOrder.automobileAndTouringClubFinland.repairShopId){

    const repairShopId = towingOrder.automobileAndTouringClubFinland.repairShopId;
    return repairShops.find(shop => shop.id === repairShopId);
  }
}
